export const environment = {
  production: true,
  baseUrl: 'https://api.dah-online.com',
  cabinetBaseUrl: 'https://cabinet.dah-online.com',
  tempCabinetBaseUrl: 'https://temp.cabinet.dah-online.com',
  ws: 'api.dah-online.com',
  pbxUrl: 'pbx.dah-online.com',
  openApiLink: 'https://open.api.dah-online.com/swagger-ui/index.html'
};
